// import $ from 'jquery';
// import Swiper from 'swiper/bundle';
// import 'swiper/css';
import Lenis from '@studio-freight/lenis'
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
// import * as THREE from "three";
import OrbBgAnimation from './orbbganimation';
// import vanilla-tilt from 'vanilla-tilt';
import vanillaTilt from 'vanilla-tilt';
import ShuffleText from 'shuffle-text';


const breakPoint = 768;
const smartBreakPointMediaQuery = "(min-width: " + breakPoint + "px)";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const isSmartPhone = () => {
  if (window.matchMedia && window.matchMedia('(max-device-width: ' + breakPoint + 'px)').matches) {
    return true;
  } else {
    return false;
  }
};


/**
 * @desc 一文字づつ文字をラップする
 * @param {*} target 
 * @returns 一文字つづspanでラップしたテキスト
 */
const spanWrapText = (target) => {
  const nodes = [...target.childNodes]; // ノードリストを配列にする
  let returnText = ''; // 最終的に返すテキスト

  for (const node of nodes) {
    if (node.nodeType == 3) {
      //テキストの場合
      const text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
      const splitText = text.split(''); // 一文字ずつ分割
      for (const char of splitText) {
        returnText += `<span>${char}</span>`; // spanタグで挟んで連結
      }
    } else {
      returnText += node.outerHTML;
    }
  }
  return returnText;
};

const spanWrapTextElements = document.querySelectorAll('.js-spanwrap')
if (spanWrapTextElements) {
  // console.log(spanWrapTextElements)
  spanWrapTextElements.forEach((spanWrapTextElement) => {
    spanWrapTextElement.innerHTML = spanWrapText(spanWrapTextElement)
  });
}


const initEnterActive1 = () => {
  const enteractives1 = gsap.utils.toArray('.js-enter-active');
  if (!enteractives1) {
    return
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        // 一度だけ発火する場合は以下で監視を解除
        // observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 10%以上表示されたら
  });
  enteractives1.forEach(target => {
    observer.observe(target);
  });
}
const initEnterActive2 = () => {
  const enteractives2 = gsap.utils.toArray('.js-enter-active--center');
  if (!enteractives2) {
    return
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        // 一度だけ発火する場合は以下で監視を解除
      }
    });
  }, {
    threshold: 0.5 // 10%以上表示されたら
  });
  enteractives2.forEach(target => {
    observer.observe(target);
  });
}

const initLenis = function () {
  const lenis = new Lenis({
    lerp: 0.1,
  });

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
}


const initLoadingAnimation = function () {
  const loading = document.querySelector(".js-loading");
  const headline = document.querySelector(".js-mv-headline");
  const message = document.querySelector(".js-mv-message");
  const lead = document.querySelector(".js-mv-lead");
  const heroSlider = document.querySelector(".js-hero-slider");
  const circles = document.querySelector(".js-hero-circles");
  const loadingLogo = document.querySelector(".js-loading-logo");
  const hamburgerMenu = document.querySelector(".hamburger-menu");
  const headerLogo = document.querySelector(".header__logo");
  const headerLinks = document.querySelectorAll(".header__link");
  const isLoaded = function () {
    const body = document.querySelector('body');
    const fv = document.querySelector('.js-first-view');
    body.classList.add("is-loaded")
    fv.classList.add("is-loaded")
    if (!isSmartPhone()) {
      initLenis()
    }
    sessionStorage.setItem('is_first', 1);
  };
  const is_first = sessionStorage.getItem('is_first');

  let firstDelay = 2;
  if (!loading) {
    return;
  }
  if (is_first) {
    firstDelay = 0.1;
    // gsap.to(loading,{
    //   duration: .5,
    //   opacity: 0,
    //   onComplete: isLoaded,
    // })

    const loadTl = gsap.timeline({ onComplete: isLoaded });
    loadTl.to(loadingLogo, {
      delay: firstDelay,
      duration: .5,
      opacity: 0,
    })
    loadTl.to(loading, {
      delay: 0,
      duration: .15,
      opacity: 0,
    })
    gsap.set(headline, {
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
    gsap.set(message, {
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
    gsap.set(lead, {
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
    gsap.set(circles, {
      opacity: 1,
    })
    gsap.set(heroSlider, {
      opacity: 1,
    })
    gsap.set(circles, {
      "--circle-pos-x": "34%",
      "--circle-pos-y": "0"
    })
    gsap.set(hamburgerMenu, {
      opacity: 1,
    })
    gsap.set(headerLogo, {
      opacity: 1,
    })
    gsap.set(headerLinks, {
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
  } else {

    const loadTl = gsap.timeline({ onComplete: isLoaded });
    loadTl.to(loadingLogo, {
      delay: firstDelay,
      duration: .5,
      opacity: 0,
    })
    loadTl.to(loading, {
      delay: 0,
      duration: .15,
      opacity: 0,
    })
    loadTl.to(headline, {
      duration: .5,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
    loadTl.to(message, {
      duration: .75,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    })
    loadTl.to(lead, {
      duration: .75,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    }, "<")
    loadTl.to(circles, {
      delay: 0,
      opacity: 1,
      duration: .3,
    })
    loadTl.to(heroSlider, {
      delay: 0,
      opacity: 1,
      duration: .3,
    }, "<")

    mm.add('(min-width: ' + (breakPoint + 1) + 'px)', () => {
      loadTl.to(circles, {
        delay: 0,
        duration: .5,
        keyframes: {
          "0%": { '--circle-pos-x': '0', '--circle-pos-y': '0', },
          "50%": { '--circle-pos-x': '9rem', '--circle-pos-y': '12.4rem', },
          "100%": { '--circle-pos-x': '34%', '--circle-pos-y': '0', },
        },
        ease: 'none'
      })
    });
    mm.add('(max-width: ' + (breakPoint) + 'px)', () => {
      loadTl.to(circles, {
        delay: 0,
        duration: .5,
        keyframes: {
          "0%": { '--circle-pos-x': '0', '--circle-pos-y': '0', },
          "50%": { '--circle-pos-x': '5rem', '--circle-pos-y': '12.4rem', },
          "100%": { '--circle-pos-x': '10rem', '--circle-pos-y': '0', },
        },
        ease: 'none'
      })
    })
    // --circle-pos-x: 10rem;

    loadTl.to(hamburgerMenu, {
      opacity: 1,
    }, "<")
    loadTl.to(headerLogo, {
      opacity: 1,
    }, "<")
    loadTl.to(headerLinks, {
      duration: .05,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
    }, "<")
  }
};

const initTopContactCircleAnimation = function () {
  const circle1 = document.querySelector(".js-circle--1");
  const circle2 = document.querySelector(".js-circle--2");
  const circle3 = document.querySelector(".js-circle--3");

  const circle1SP = document.querySelector(".js-circle--1_sp");
  const circle2SP = document.querySelector(".js-circle--2_sp");
  const circle3SP = document.querySelector(".js-circle--3_sp");

  const circles = document.querySelector(".contact-circles");
  const trigger = document.querySelector(".js-contact-section");

  if (!circle1 || !circle2 || !circle3) {
    return;
  }
  let scrollTriggerOptions = {
    trigger: trigger,
    // markers: true,
    scrub: 1,
    start: 'top top',
    end: 'bottom bottom',
  };
  if (isSmartPhone()) {
    let scrollTriggerOptions = {
      trigger: circles,
      // markers: true,
      scrub: 1,
      start: 'top top',
      end: 'bottom bottom',
    };
    gsap.set(circles, {
      y: "40.5rem",
      x: "2rem",
      rotate: 450,
    })
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          gsap.to(circle1SP, {
            x: 0,
            y: "4rem",
            // y: "10.5rem",
            // scrollTrigger: scrollTriggerOptions,
          });
          gsap.to(circle2SP, {
            scale: 1,
            opacity: 1,
            // scrollTrigger: scrollTriggerOptions,
          });
          gsap.to(circle3SP, {
            x: 0,
            y: "-4rem",
            // y: "-10.5rem",
            // scrollTrigger: scrollTriggerOptions,
          });
          // 一度だけ発火する場合は以下で監視を解除
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2 // 10%以上表示されたら
    });
    observer.observe(circles);
    return;
  }

  gsap.set(circles, {
    y: -500,
    rotate: 0,
  })
  gsap.set(circle1, {
  })
  gsap.set(circle3, {
  })

  mm.add('(min-width: ' + (breakPoint + 1) + 'px)', () => {
    gsap.to(circles, {
      y: "51.5rem",
      x: "16rem",
      rotate: 450,
      scrollTrigger: scrollTriggerOptions,
    })
  });
  mm.add('(max-width: ' + (breakPoint) + 'px)', () => {
    // translate(2rem, 40.5rem)
    gsap.to(circles, {
      y: "40.5rem",
      x: "2rem",
      rotate: 450,
      scrollTrigger: scrollTriggerOptions,
    })
  });
  gsap.to(circle1, {
    x: 0,
    y: "17.5rem",
    // y: "10.5rem",
    scrollTrigger: scrollTriggerOptions,
  });
  gsap.to(circle2, {
    scale: 1,
    opacity: 1,
    scrollTrigger: scrollTriggerOptions,
  });
  gsap.to(circle3, {
    x: 0,
    y: "-17.5rem",
    // y: "-10.5rem",
    scrollTrigger: scrollTriggerOptions,
  });

  gsap.to(circle1SP, {
    x: 0,
    y: "4rem",
    // y: "10.5rem",
    scrollTrigger: scrollTriggerOptions,
  });
  gsap.to(circle2SP, {
    scale: 1,
    opacity: 1,
    scrollTrigger: scrollTriggerOptions,
  });
  gsap.to(circle3SP, {
    x: 0,
    y: "-4rem",
    // y: "-10.5rem",
    scrollTrigger: scrollTriggerOptions,
  });
  // gsap.to(circle2, {
  //   y: "-20rem",
  //   // x: "-8.3rem",
  //   scrollTrigger: scrollTriggerOptions,
  // });
  // gsap.to(circle3, {
  //   x: "36.6rem",
  //   y: "0",
  //   scrollTrigger: scrollTriggerOptions,
  // });
};

const initXScrollCard = () => {
  const card = gsap.utils.toArray('.js-x-scroll-item');
  const wrapper = document.querySelector('.js-x-scroll');
  if (card.length === 0) {
    return false;
  }
  const containerWidth = wrapper.offsetWidth;
  mm.add(smartBreakPointMediaQuery, () => {
    gsap.to(card, {
      xPercent: -80 * (card.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: wrapper,
        pin: true,
        scrub: 1,
        start: "top top",
        end: `+=${(containerWidth)}`,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });

  });
}
const initSectionBgChanger = function () {
  const boxs = gsap.utils.toArray('.js-toggle-section-bg');
  if (boxs.length === 0) {
    return false;
  }
  if (isSmartPhone()) {
    boxs.forEach((box) => box.classList.add("is-active"))
    return;
  }
  const onEnterToggleAction = (box) => {
    box.classList.add('is-active')
  }
  const onLeaveToggleAction = (box) => {
    box.classList.remove('is-active')
  }
  boxs.forEach((box, index) => {
    gsap.to(box, {
      scrollTrigger: {
        trigger: box,
        // markers: true,
        start: isSmartPhone() ? 'top bottom-=500' : 'top bottom',
        end: isSmartPhone() ? 'bottom top+=200' : 'bottom center',
        onEnter: () => onEnterToggleAction(box),
        onEnterBack: () => onEnterToggleAction(box),
        onLeave: () => onLeaveToggleAction(box),
        onLeaveBack: () => onLeaveToggleAction(box),
      }
    });
  });
}

const initBganimation = function () {
  const bganimtion = document.querySelector('.js-bg-animation');
  if (!bganimtion) {
    return;
  }
  const init = async () => {
    const orbBg = new OrbBgAnimation(bganimtion, {
      orb1Color: '#31F8F6',
      orb2Color: '#F66B31',
      orb3Color: '#2D2D42',
      // orb3Color: '#ff0000',
      bgColor: '#1c1c1c'
    });
    await orbBg.initObject()
    // orbBg.initGui()
    orbBg.tick()
    orbBg.resize()
  }
  init()
};

const initVanillaTilt = () => {
  const tiltElements = document.querySelectorAll('.js-tilt');
  if (!tiltElements) {
    return;
  }
  tiltElements.forEach((element) => {
    vanillaTilt.init(element, {
      max: 10,
      speed: 400,
      glare: true,
      "max-glare": 0.2,
      scale: 1.05,
    });
  });
};

const initShuffleText = () => {
  const elements = document.querySelectorAll(".js-shuffle-text");
  if (!elements) {
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        new ShuffleText(entry.target).start()
        // 一度だけ発火する場合は以下で監視を解除
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1 // 10%以上表示されたら
  });
  elements.forEach(target => {
    observer.observe(target);
  });

};



const initStackSections = () => {
  const sections = document.querySelectorAll('.js-section');
  sections.forEach((section) => {
    const pin = section.querySelector('.js-section__pin');
    const height = section.getBoundingClientRect().height;
    gsap.set(pin, {
      height: height,
    });
    if (!isSmartPhone()) {
      gsap.set(section, {
        height: height + 0,
      });

    } else {
      gsap.set(section, {
        height: height + 0,
      });

    }


    ScrollTrigger.create({
      trigger: section,
      start: 'bottom bottom',
      onEnter: () => {
        gsap.set(pin, {
          position: 'fixed',
          // top: 0,
          // bottom: "auto",
          marker: true,
          top: 'auto',
          bottom: 0,
          left: 0,
        });

      },
      onLeaveBack: () => {
        gsap.set(pin, {
          position: 'absolute',
          top: 'auto',
          bottom: 0,
          // top: 0,
          // bottom: 'auto',
          left: 0,
        });
      },
    });
  });
};


window.scrollTo(0, 0)
let mm = gsap.matchMedia();
initStackSections()
initEnterActive1()
initEnterActive2()
initLoadingAnimation()
initXScrollCard()
initSectionBgChanger()
initBganimation()
initTopContactCircleAnimation()
initVanillaTilt()
initShuffleText()
mm.add('(min-width: ' + (breakPoint + 1) + 'px)', () => {
});
mm.add('(max-width: ' + (breakPoint) + 'px)', () => {
});

const resizeEvent = () => {
  gsap.delayedCall(0.2, ScrollTrigger.refresh);
}
window.addEventListener('resize', resizeEvent)




